'use es6';

export const DEFAULT = 'default';
export const HELP_TEXT = 'help_text';
export const INLINE_HELP_TEXT = 'inline_help_text';
export const LABEL = 'label';
export const NAME = 'name';
export const CHOICES = 'choices';
export const DISPLAY = 'display';
export const VALIDATION_REGEX = 'validation_regex';
export const VALIDATION_ERROR_MESSAGE = 'validation_error_message';
export const MIN = 'min';
export const MAX = 'max';
export const STEP = 'step';
export const REQUIRED = 'required';
export const PICKER = 'picker';
export const CHILDREN = 'children';
export const OCCURRENCE = 'occurrence';
export const VISIBILITY = 'visibility';
export const LOCKED = 'locked';
export const PLACEHOLDER = 'placeholder';
export const RESIZABLE = 'resizable';
export const RESPONSIVE = 'responsive';
export const SHOW_LOADING = 'show_loading';
export const TAG_VALUE = 'tag_value';
export const SUPPORTED_TYPES = 'supported_types';
export const SHOW_EMOJI_PICKER = 'show_emoji_picker';
export const ALLOW_NEW_LINE = 'allow_new_line';
export const ENABLED_FEATURES = 'enabled_features';
export const OBJECT_TYPE = 'object_type';
export const PROPERTIES_TO_FETCH = 'properties_to_fetch';
export const DISPLAY_PROPERTIES = 'display_properties';
export const SUPPORTED_SOURCE_TYPES = 'supported_source_types';
export const SUPPORTED_OEMBED_TYPES = 'supported_oembed_types';
export const SUPPORTED_MEDIA_BRIDGE_PROVIDERS = 'supported_media_bridge_providers';
export const EXPANDED = 'expanded';
export const ICON_SET = 'icon_set';
export const COLUMNS_TO_FETCH = 'columns_to_fetch';
export const DISPLAY_COLUMNS = 'display_columns';
export const DISPLAY_FORMAT = 'display_format';
export const TABLE_NAME_OR_ID = 'table_name_or_id';
export const ALLOW_CUSTOM_BORDER_SIDES = 'allow_custom_border_sides';
export const PREFIX = 'prefix';
export const SUFFIX = 'suffix';
export const SHOW_PREVIEW = 'show_preview';
export const SHOW_ADVANCED_OPTIONS = 'show_advanced_options';
export const SHOW_ADVANCED_REL_OPTIONS = 'show_advanced_rel_options';
export const MULTIPLE = 'multiple';
export const REORDERING_ENABLED = 'reordering_enabled';
export const SHOW_OPACITY = 'show_opacity';